import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import TopNav from '../../../components/TopNav';
import OfflineNotificationBar from '../../../components/OfflineNotificationBar';
import AccountantSideNav from './AccountantSideNav';

const AccountantLayout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [notificationVisible, setNotificationVisible] = useState(false);
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleSwitchToClientView = () => {
    navigate('/dashboard');
  };

  useEffect(() => {
    const handleNotificationVisibility = (event) => {
      setNotificationVisible(event.detail.visible);
    };

    window.addEventListener('offlineNotificationVisibility', handleNotificationVisibility);
    return () => {
      window.removeEventListener('offlineNotificationVisibility', handleNotificationVisibility);
    };
  }, []);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <TopNav onMenuClick={handleDrawerToggle} />
      <OfflineNotificationBar />
      <AccountantSideNav
        mobileOpen={mobileOpen}
        onMobileClose={handleDrawerToggle}
        onSwitchToClientView={handleSwitchToClientView}
      />
      <Box
        component="main"
        className="accountant-portal-content"
        sx={{
          flexGrow: 1,
          flexBasis: 0,
          p: 0,
          width: { xs: '100%', md: 'auto' },
          maxWidth: 'none',
          mt: notificationVisible ? { xs: '98px', sm: '92px' } : '70px',
          backgroundColor: '#f8f9fa',
          boxSizing: 'border-box',
          minWidth: 0,
          overflowX: 'hidden',
          minHeight: notificationVisible ? { xs: 'calc(100vh - 98px)', sm: 'calc(100vh - 92px)' } : 'calc(100vh - 70px)',
          transition: 'margin-top 0.3s ease-in-out, min-height 0.3s ease-in-out',
        }}
      >
        <Box
          className="accountant-page-container"
          sx={{
            width: '100%',
            maxWidth: 1400,
            mx: 'auto',
            p: { xs: 2, sm: 3 },
            boxSizing: 'border-box',
            minWidth: 0,
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default AccountantLayout;
